import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
// import { Tooltip } from 'antd';
import { getAlignerBackground, getAlignerNumberBackground } from "../../utils";

const Aligners = ({ alignersObj, alignerType }) => {
  const targetDivRef = useRef(null);
  useEffect(() => {
    if (targetDivRef.current) {
      // Scroll to the bottom of the div
      targetDivRef.current.scrollTop = targetDivRef.current.scrollHeight;
      // targetDivRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [targetDivRef, alignersObj]);


  return (
    <div
      ref={alignerType === "upper" ? targetDivRef : null}
      className={
        alignersObj.length > 6
          ? "aligners-container aligner-scroll-container"
          : "aligners-container"
      }
    >
  {alignersObj?.map((upperAligner, upperIndex) => (
  <div
    key={upperIndex}
    className={upperAligner?.selected ? "selected-aligner aligner-rows" : "aligner-rows"}
  >
    <div className="aligner-row">
      {upperAligner?.alignerValues.length > 0 ? (
        upperAligner?.alignerValues.map((aligner, alignerIndex) => (
          <div
            key={alignerIndex}
            style={{
              background: getAlignerBackground(aligner, upperAligner),
            }}
            className={`aligner-circle aligner-${alignerType} 
              ${
                alignerType === "upper"
                  ? aligner.value && upperIndex === alignersObj.length - 1
                    ? `aligner-0-upper`
                    : ""
                  : aligner.value
                  ? `aligner-${upperIndex}-${alignerType} aligner-${alignerType}`
                  : ""
              }
            `}
          >
            {aligner.value}
          </div>
        ))
      ) : (
        // Render a hidden placeholder when alignerValues is empty
        <div className="aligner-circle" style={{ opacity: 0 }}>--</div>
      )}
    </div>
  </div>
))}

    </div>
  );
};

export default Aligners;

Aligners.propTypes = {
  alignersObj: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        session: PropTypes.number.isRequired,
        // Add more PropTypes for other properties if needed
      })
    )
  ).isRequired,
};
